import { render, staticRenderFns } from "./singlepayoutdetails.vue?vue&type=template&id=59c766b6"
import script from "./singlepayoutdetails.vue?vue&type=script&lang=js"
export * from "./singlepayoutdetails.vue?vue&type=script&lang=js"
import style0 from "./singlepayoutdetails.vue?vue&type=style&index=0&id=59c766b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports